<!--
 * @Descripttion:
 * @version:
 * @Author: xiexing
 * @Date: 2020-05-08 14:48:39
 * @LastEditors: xiexing
 * @LastEditTime: 2022-04-26 13:42:38
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import { setShare } from '@/lib/share'
export default {
  name: 'App',
  data() {
    return {
      shareParams: {
        pic: 'https://pic3.zhuanstatic.com/zhuanzh/n_v2bba756af71bd45a6913ea9da62d84f14.png',
        url: 'https://m.caihuoxia.com/u/hunter-market/index?__nousehashparam=1',
        title: '你竟然还不知道！这里采货巨便宜！快来看看 >>',
        waImg: 'https://pic6.zhuanstatic.com/zhuanzh/n_v2bba756af71bd45a6913ea9da62d84f14.png'
      }
    }
  },
  created() {},
  methods: {
    addDnsPrefetch(domain) {
      const link = document.createElement('link')
      link.rel = 'dns-prefetch'
      link.href = domain
      document.head.appendChild(link)
    },
    getInviteInfo() {
      this.$http
        .get('/zzopen/ypofflinemart/getInviteBaseInfo', {})
        .then((res) => {
          this.inviteInfo = res
          this.shareParams.url = `https://m.caihuoxia.com/u/hunter-market/index?__nousehashparam=1&inviteCode=${this.inviteInfo.inviteCode}`
          this.initShare()
        })
        .catch(() => {})
    },
    initShare() {
      setTimeout(() => {
        this.isMini && setShare(this.shareParams)
      })
    }
  }
}
</script>

<style lang="scss">
@import './assets/css/reset.css';
@import './assets/css/common.scss';
</style>
